module.exports = __webpack_public_path__ + "static/media/battery_90.2f5490c8.svg";